export default "__VITE_ASSET__Ht8CzRuw__"